import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logUsage } from 'owa-analytics';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7006 (7,44): Parameter 'eventName' implicitly has an 'any' type.
// @ts-expect-error
export function logUsageBasedOnPremiumFlag(eventName, customData = null) {
    // we are unable to identify whether a user is premium or not as this information
    // is not loaded when the user is accessing its cloud cache account.
    // thus, we cannot rely solely on the IsPremiumConsumerMailbox flag for now
    const customEventName = getUserConfiguration().SessionSettings?.IsShadowMailbox
        ? `${eventName}Unknown`
        : getUserConfiguration().SessionSettings?.IsPremiumConsumerMailbox
        ? eventName
        : `${eventName}NonPremium`;

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (20,31): Argument of type 'null' is not assignable to parameter of type 'CustomData | undefined'.
    // @ts-expect-error
    logUsage(customEventName, customData, { isCore: true });
}
